import React from 'react';
import { DatePicker } from 'clad';

const Datepicker = React.forwardRef((props, ref) => {
    const { value, onChange } = props;

    const handleChange = value => {
        if (onChange) onChange(value);
    };

    return (
        <DatePicker
            format={Cla.ui.date.userDateFormat(Prefs)}
            onChange={handleChange}
            value={value}
        />
    );
});

export default Datepicker;
